var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import CartService from "webshop/services/CartService";
// Webshop
import WebshopEvents, { WebshopEventTypes } from "webshop/utilities/WebshopEvents";
import { EventTypes } from "webshop/models/EventTypes";
import CheckoutShippingMethods from "webshop/components/checkout/shipping/CheckoutShippingMethods.vue";
import CheckoutOrderSummary from "webshop/components/checkout/CheckoutOrderSummary.vue";
import { ErrorService } from "webshop/services/ErrorService";
import RedeemPromotionCode from "../../components/promotion-codes/RedeemPromotionCode.vue";
let CheckoutShipping = class CheckoutShipping extends Vue {
    constructor() {
        super(...arguments);
        this.cart = null;
        this.selectedShippingMethod = null;
    }
    get promotionCodesEnabled() {
        return false;
    }
    mounted() {
        CartService.getCart().then(cart => {
            // Hvis cart returner 204 No content er kurven tom og de skal sendes tilbage
            if (typeof (cart) === "string") {
                this.$router.push("cart");
                return;
            }
            // Hvis cart.shippingRequired er falsk, er brugerne landet her ved en fejl og skal sendes tilbage
            if (!cart.shippingRequired) {
                this.$router.push("cart");
                return;
            }
            this.cart = cart;
            WebshopEvents.$emit(WebshopEventTypes.CheckoutUpdateCart, cart);
        }, err => {
            ErrorService.handleError(err);
        });
        // Update checkout progress
        WebshopEvents.$emit(EventTypes.UpdateStep, 3);
    }
    onGoToPayment() {
        this.$router.push("payment");
    }
    onSelectShippingMethod(value) {
        this.selectedShippingMethod = value;
    }
};
CheckoutShipping = __decorate([
    Component({
        components: {
            CheckoutShippingMethods,
            CheckoutOrderSummary,
            RedeemPromotionCode
        }
    })
], CheckoutShipping);
export default CheckoutShipping;
